import React from 'react';
import '../style/status.css'

export function Completed() {
    return (
        <div className='Completed'>Completed</div>
    );
}

export function NotCompleted() {
    return (
        <div className='NotCompleted'>Not Completed</div>
    );
}


